<!-- 检查订单 -->
<template>
  <el-drawer
    title="检查订单"
    direction="rtl"
    class="check-order"
    :visible="isShow"
    :size="588"
    :modal="false"
    :wrapperClosable="false"
    :modal-append-to-body="false"
    :show-close="false"
    :append-to-body="true"
    @close="close"
  >
    <template v-slot:title>
      <div class="check-order__handle" @click="close">
        <img :src="require('@@/assets/img/icons/icon_drawer_1.png')" />
      </div>
    </template>
    <div class="check-order__container">
      <div class="check-order__header">
        <span>检查订单</span>
        <p class="check-order__header__close" @click="close">
          <i class="el-icon-close"></i>
        </p>
      </div>

      <el-scrollbar class="check-order__scrollbar">
        <div class="check-order__content">
          <div v-for="(item, index) in showFields" :key="index">
            <p class="check-order__title">
              {{ item.title }}
            </p>
            <!-- PCB文件 -->
            <div 
              v-if="item.title === 'PCB文件'"
              :class="`check-order__pcbfile ${!format.pcbfile.error ? 'is-success' : 'is-error'}`"
              @click="handleItemClick('pcbfile', format.pcbfile)"
            >
              <template v-if="!format.pcbfile.error">
                {{ format.pcbfile.value }}
              </template>
              <template v-else>
                <i class="el-icon-upload2"></i>
                {{ format.pcbfile.tips }}
              </template>
            </div>
            <div v-else class="check-order__descriptions">
              <template v-for="field in item.list" >
                <div 
                  v-if="format[field].show"
                  :key="field"
                  class="check-order__descriptions__item"
                  :class="{ 'is-error': format[field].error }"
                  @click="handleItemClick(field, format[field])"
                >
                  <span class="check-order__descriptions__label">
                    {{ format[field].label }}
                  </span>
                  <span class="check-order__descriptions__value">
                    <ColorBlock v-if="field === 'color'" :color="pcbParams.color" />
                    {{ format[field].error ? format[field].tips : format[field].value }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </el-scrollbar>

      <div class="check-order__footer">
        <el-button 
          round 
          type="primary" 
          class="check-order__footer__submit"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          确认下单
        </el-button>
        <div class="check-order__footer__content">
          <p>
            预估总价：
            <span>
              <i>￥</i>
              <QuoteAnimateNumber :num="priceTotal.total_amount" />
            </span>
          </p>
          <span>仅供参考，最终价格以审核后为准</span>
        </div>
        <!-- 免责声明 -->
        <div class="check-order__footer__disclaimers">
          <Disclaimers v-model="pcbParams.agreen_disclaimers" />
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
// 数字跳动效果
import QuoteAnimateNumber from '@@/components/common/quoteAnimateNumber'
// 阻焊颜色色块
import ColorBlock from '@@/components/colorBlock/index'
// 免责声明
import Disclaimers from '@@/views/pcbQuote/right/disclaimers'

import { showFields, fieldsFormat } from './fieldsFormat'

export default {
  props: {
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QuoteAnimateNumber,
    ColorBlock,
    Disclaimers
  },
  // 来源：pcbQuote/index.vue
  inject: {
    pcbParams: { default: {} },
    getPriceTotal: { default: () => ({}) },
  },
  data() {
    return {
      isShow: false,
      currentKey: '', // 当前字段
    }
  },
  computed: {
    // 获取实时的计价数据
    priceTotal() {
      return this.getPriceTotal()
    },
    showFields() {
      return showFields(this.pcbParams.board_type)
    },
    format() {
      return fieldsFormat(this.pcbParams)
    }
  },
  methods: {
    show() {
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    handleItemClick(key, item) {
      this.$emit('scroll', key)
      // 第二次点击同一个字段 且 该字段校验没通过时，显示抖动动画
      if (this.currentKey === key && item.error) {
        this.$emit('shake', key)
      }
      this.currentKey = key
    },
    handleSubmit() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="scss" scoped>
.check-order {
  pointer-events: none;
  ::v-deep {
    .el-drawer {
      pointer-events: auto;
      overflow: visible;
    }
    .el-drawer__header {
      position: absolute;
      left: -20px;
      top: 45%;
      padding: 0;
      margin: 0;
      width: 22px;
      height: 61px;
      cursor: pointer;
    }
  }
}

$headerHeight: 40px;
$footerHeight: 68px;
$errorColor: $--color-danger;
$errorBgColor: #FEF0F0;

.check-order__container {
  height: 100%;
  .check-order__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: $headerHeight;
    padding: 0 20px;
    >span {
      font-size: 13px;
      font-weight: 700;
      color: #333333;
    }
    .check-order__header__close {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      font-size: 16px;
      color: #666;
      border-radius: 3px;
      cursor: pointer;
      &:hover {
        color: #111;
        background-color: #f5f5f5;
      }
      >i {
        font-weight: 700;
      }
    }
  }
  .check-order__scrollbar {
    height: calc(100% - $headerHeight - $footerHeight);
    ::v-deep {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
  }
}

.check-order__content {
  padding: 0 20px 20px;
  .check-order__title {
    margin: 10px 0 6px;
    font-size: 13px;
    color: #999999;
  }
  .check-order__pcbfile {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    font-size: 12px;
    word-break: break-all;
    background-color: #F5F5F5;
    cursor: pointer;
    &.is-success {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        display: block;
        width: 3px;
        height: 16px;
        border-radius: 3px;
        background-color: $--form-color-base;
      }
    }
    &.is-error {
      color: $errorColor;
      border-radius: $--border-radius-base2;
      background-color: $errorBgColor;
    }
    >i {
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .check-order__descriptions {
    $itemHeight: 30px;
    $borderColor: #E6E6E6;
    font-size: 13px;
    border: 1px solid $borderColor;
    .check-order__descriptions__item {
      display: flex;
      cursor: pointer;
      &:not(:last-child) {
        border-bottom: 1px solid $borderColor;
      }
      &.is-error {
        .check-order__descriptions__value {
          color: $errorColor;
          background-color: $errorBgColor;
        }
      }
    }
    .check-order__descriptions__label {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      padding-left: 9px;
      width: 126px;
      color: #555555;
      border-right: 1px solid $borderColor;
      background-color: #F5F5F5;
    }
    .check-order__descriptions__value {
      flex: 1;
      display: flex;
      align-items: center;
      padding-left: 9px;
      min-height: $itemHeight;
      color: #1A1A1A;
      background-color: #FDFDFD;
    }
  }
}

.check-order__footer {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: $footerHeight;
  background-color: #F5F5F5;
  .check-order__footer__submit {
    width: 180px;
    font-size: 14px;
    color: #FFFFFF;
    border-color: #15A675;
    background-color: #15A675;
    &:hover, &:focus {
      border-color: #14A070;
      background-color: #14A070;
    }
    &:active {
      border-color: #138F64;
      background-color: #138F64;
      box-shadow: 0px 0px 3px 0px #aaaaaa;
    }
  }
  .check-order__footer__content {
    margin-left: 10px;
    >p {
      font-size: 13px;
      font-weight: 700;
      color: #111111;
      >span {
        margin-left: -8px;
        font-size: 22px;
        color: #D9001B;
        >i {
          font-size: 14px;
        }
      }
    }
    >span {
      font-size: 12px;
      color: #AAAAAA;
    }
  }
  .check-order__footer__disclaimers {
    display: flex;
    align-items: flex-end;
    margin-left: 10px;
    height: 46px;
  }
}
</style>